import React from 'react';

//Hooks
import {useSelector} from "react-redux";

//Components
import {ChevronLeft, ChevronRight} from "react-feather";

//Styles
import Styles from './WeekPicker.module.scss';

//Utils
import moment from "moment";

const WeekPicker = ({date, onPressPrev, onPressNext}) => {
    const locale = useSelector(state => state.locales.locale);

    const start = date.clone().locale(locale).startOf('isoWeek');
    const end = date.clone().locale(locale).endOf('isoWeek');
    return (
        <div className={Styles.container}>
            {!start.isBefore(moment()) && (
                <button className={Styles.arrowButton} onClick={onPressPrev}>
                    <ChevronLeft className={Styles.arrow} size={28}/>
                </button>
            )}

            <span className={Styles.title}>
                {`${moment(start).format('DD')}${moment(start).month() !== moment(end).month() ? ` ${moment(start).format('MMMM')}` : ''} - ${moment(end).format('DD')} ${moment(end).format('MMMM')}`}
            </span>

            <button className={Styles.arrowButton} onClick={onPressNext}>
                <ChevronRight className={Styles.arrow} size={28}/>
            </button>
        </div>
    )
};

export default WeekPicker